import React from 'react';
import { Box } from '@mui/material';
import { DrawerProvider } from '../../contexts/DrawerContext';
import TopNavigationBar from './TopNavigationBar';
// import BottomNavigationBar from './BottomNavigationBar';
import Sidebar from '../sidebar';
import MainContentLayout from './MainContentLayout';

/**
 * AppLayout component - Main layout wrapper that combines TopNavigationBar, Sidebar, and MainContentLayout
 * 
 * This component provides the overall page structure:
 * - TopNavigationBar at the top (fixed position)
 * - Sidebar on the left (responsive behavior)
 * - MainContentLayout for the main content area
 * 
 * The layout automatically adjusts for:
 * - Mobile vs desktop responsive behavior
 * - Sidebar open/closed states
 * - Top navigation bar height offset
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render in the main content area
 * @returns {JSX.Element} AppLayout component
 */
const AppLayout = ({ children }) => {
  return (
    <DrawerProvider>
      {/* Skip navigation link for accessibility */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>

      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100dvh', width: '100dvw' }}>
        {/* Top Navigation Bar */}
        <TopNavigationBar />
        
        {/* Main layout container */}
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
          }}
        >
          {/* Sidebar */}
          <Sidebar />

          {/* Main Content Area */}
          <MainContentLayout>
            {children}
          </MainContentLayout>
        </Box>

        {/* Bottom Navigation Bar - Mobile only */}
        {/* <BottomNavigationBar /> */}
      </Box>
    </DrawerProvider>
  );
};

export default AppLayout;
